import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
  Label,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import { type FC, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncFn } from "react-use";

interface ForkRestartDialogProps {
  executionId: string;
  open?: boolean;
  onOpen?: (open: boolean) => void;
}

const ForkRestartDialog: FC<ForkRestartDialogProps> = props => {
  const { executionId, open, onOpen } = props;
  const navigate = useNavigate();
  const forceRef = useRef(false);

  const [{ loading, error }, submit] = useAsyncFn(async () => {
    const { executionId: exId, alias } = await api.restart(
      executionId,
      forceRef.current,
    );
    const idOrAlias = alias ?? exId;
    if (window.location.pathname.includes(`forks/${idOrAlias}`)) {
      window.location.reload();
    } else {
      navigate(`/forks/${idOrAlias}/status`);
    }
  }, [executionId, navigate]);

  const onForceChange = useCallback((checked: boolean) => {
    forceRef.current = checked;
  }, []);

  return (
    <Dialog modal open={open} onOpenChange={onOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Restart fork</DialogTitle>
          <DialogDescription>Please confirm fork restart</DialogDescription>
        </DialogHeader>

        <div className="flex items-center gap-2">
          <Checkbox
            id="force-restart"
            onCheckedChange={onForceChange}
            disabled={loading}
          />
          <Label htmlFor="force-restart">Force</Label>
        </div>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            disabled={loading}
            onClick={submit}
            loading={loading}
          >
            Restart fork
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ForkRestartDialog;
